import ForgotPassword from "../components/Login/ForgotPassword";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
